/**
 * The gap that says: what is on the other side of this is not what is on this side.
 *
 * It started as a bare 24 px spacer in front of `Wort löschen` and `Löschen`, for a reason worth keeping
 * in one place — **a mis-hit that deletes the sentence instead of saying "ja" is exactly the failure this
 * person cannot afford.** Real space, because colour is not something to bet a sentence on, and a rule as
 * well as space so the separation survives whatever the theme or the person's colour vision does to it
 * (§5.2: never encode meaning in colour alone).
 *
 * Now used twice: in the bottom bar in front of the destructive pair, and in the contextual band in front of
 * the layer switch. The two cases are the same case. On one side are things that speak; on the other is
 * something that changes the device under the person's hands — and the gap outlived the control it was first
 * put there for, the `Leichter` toggle, because the rule was never about that control (GEO-10).
 */
export function ProtectiveGap(): React.JSX.Element {
  return (
    <span
      aria-hidden="true"
      style={{
        flex: '0 0 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <span style={{ width: 2, height: '70%', background: 'var(--divider)' }} />
    </span>
  );
}
